import axios from 'axios';
let baseURL = 'https://api-arco-iris.onrender.com';

if (window.location.href.search('192.168.0.200') != -1) {baseURL= 'https://api-arco-iris.onrender.com'}

	const api = axios.create({
		baseURL: baseURL
    //baseURL: 'http://ftptrade.ddns.net:3001/',
    //baseURL: 'http://187.86.147.193:5001/',
});
export default api;